// tslint:disable
import { get } from 'lodash';
import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
import { DatepickerField } from '../../components/fields/datepicker.field';
import { InputField } from '../../components/fields/input.field';
import { IriField } from '../../components/fields/iri.field';
import { SelectField } from '../../components/fields/select.field';
import { Field, FormLib } from '../../components/libs/form.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';
import { ResourceModal } from '../../components/structurals/resource-modal';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import * as moment from 'moment';
import {Notification} from "../../index";

export class DefaultUser extends React.Component<any, any> {
    public state: any = {
        person: null
    };
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);
    private hasEmitted: any = {};

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec(null);
    }

    handleEntityFieldFetched(form: FormLib, field: any, entity: string) {
        if (!this.hasEmitted.hasOwnProperty(entity)) {
            (form.fields[entity] as Field).setValue(get(field, 'value.@id'));
            this.hasEmitted[entity] = false;
        }
    }

    handleAttachePersonModalInitialized(ref: any) {
        // setTimeout(() => {
        //     ref.onButtonClick(null);
        // }, 10);
    }


    render() {
        return (
            <ResourceLoader entity="user" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div className="row">
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <div className="col-xs-12">
                    <div id="page-title">
                        <h2>Update user details</h2>
                    </div>
                </div>

                <div className="col-xs-12 col-md-9">
                    <ToggleBoxComponent title="User informations" alwaysOpen={true}>
                        <div className="row">
                            <div className="col-xs-12">

                                <InputField
                                    field={form.fields.firstName}
                                    validators={[Validators.required('Required')]}/>

                                <InputField
                                    field={form.fields.surName}
                                    title="SurName"
                                    validators={[Validators.required('Required')]}/>

                                <InputField
                                    field={form.fields.email}
                                    validators={[Validators.required('Required')]}/>

                                <CheckboxField
                                    title="Validate profile"
                                    field={form.fields.enabled}
                                />

                                <SelectField
                                    field={form.fields.roles}
                                    multi={true}
                                    options={[
                                        {value: 'ROLE_ADMIN', label: 'ROLE_ADMIN'},
                                        {value: 'ROLE_USER', label: 'ROLE_USER'},
                                        {value: 'ROLE_SUPERADMIN', label: 'ROLE_SUPERADMIN'},
                                        {value: 'ROLE_VISITOR', label: 'ROLE_VISITOR'},
                                    ]}
                                />

                                <InputField field={form.fields.importedTag} />

                                {this.props.ENTITY_ID == 'create' &&
                                <InputField
                                    field={form.fields.plainPassword}
                                    type="password"
                                    validators={[Validators.required('Required')]}/>
                                }

                            </div>
                        </div>
                    </ToggleBoxComponent>

                    {this.props.ENTITY_ID !== 'create' &&
                    <ToggleBoxComponent title="Person details" alwaysOpen={true}>
                        <IriField
                            field={form.fields.person}
                            defaultAll={false}
                            defaultValue={get(form.fields.person, 'value[@id]')}
                            forceQuery={{'user[exact]': false}}
                            itemRender={(item: any) => `${get(item, 'firstName', '-')} ${get(item, 'surName', '-')} - ${get(item, 'email', '-')}`}
                        />


                        {form.fields.person && form.fields.person.value &&
                        <ResourceModal
                            entity="person"
                            entityId={form.fields.person.value ? form.fields.person.value.replace('/person/', '') : ''}
                            title="Update person"
                        />}

                        {(form.fields.person && !form.fields.person.value) && !this.state.person &&
                        <ResourceModal
                            ref={'attachPersonModal'}
                            entity="person"
                            entityId="create"
                            title="Attach person"
                            config={{
                                firstName: form.fields.firstName.value,
                                surName: form.fields.surName.value,
                                email: form.fields.email.value,
                                user: '/user/' + this.props.ENTITY_ID
                            }}
                            onCreateSuccessful={(value: any) => {
                                form.fields.person.setValue(get(value, '@id'), false, true);
                            }}
                            onInitialized={(ref: any) => this.handleAttachePersonModalInitialized(ref)}
                        />}

                    </ToggleBoxComponent>
                    }

                    <ToggleBoxComponent title="Subscriptions" alwaysOpen={true}>
                        <ListResourceLoader
                            entity="user-access-subscription"
                            forceQuery={{"userAccess.user": this.props.ENTITY_ID, '_deletedAt': null}}
                            render={(list: ListLib) => <div className="w-100">
                                <ListResponsePresenterTable
                                    head={() => {
                                        return (
                                            <tr>
                                                <th>ID</th>
                                                <th>startDate</th>
                                                <th>endDate</th>
                                                <th>Site</th>
                                                <th></th>
                                            </tr>
                                        );
                                    }}
                                    row={(item: any, index: number, actions: ListActions) => this.userAccessSubscriptionsRow(item, index, actions, list)}
                                    items={list.member}/>

                                <ResourceModal
                                    entity="modal-user-access-subscription"
                                    entityId="create"
                                    config={{user: this.props.ENTITY_ID }}
                                    onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                    title={<div><i className="fa fa-plus"/> Add new subscription</div>}/>
                            </div>}
                        />
                    </ToggleBoxComponent>
                </div>

                <div className="col-xs-12 col-md-3">

                    <ToggleBoxComponent title="Access to sites" alwaysOpen={true}>
                        <ListResourceLoader
                            entity="user-access"
                            forceQuery={{user: this.props.ENTITY_ID, '_deletedAt': null}}
                            render={(list: ListLib) => <div className="w-100">
                                <ListResponsePresenterTable
                                    head={() => {
                                        return (
                                            <tr>
                                                <th>ID</th>
                                                <th>Site</th>
                                                <th></th>
                                            </tr>
                                        );
                                    }}
                                    row={(item: any, index: number, actions: ListActions) => this.userAccessRow(item, index, actions, list)}
                                    items={list.member}/>

                                <ResourceModal
                                    entity="modal-user-access"
                                    entityId="create"
                                    config={{user: `/user/${this.props.ENTITY_ID}`}}
                                    onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                    title={<div><i className="fa fa-plus"/> Add new access</div>}/>
                            </div>}
                        />
                    </ToggleBoxComponent>
                    <ToggleBoxComponent title="Properties" alwaysOpen={true}>

                        <DatepickerField
                            field={form.fields.createdAt}
                            disabled={true}/>

                        <DatepickerField
                            field={form.fields.updatedAt}
                            disabled={true}/>

                        <DatepickerField
                            field={form.fields.deletedAt}
                            disabled={true}/>

                    </ToggleBoxComponent>
                </div>

                <div className="col-xs-12">
                    <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save</button>
                </div>
            </div>}
            />
        );
    }

    handleCreateAndUpdate(pc: any, list: ListLib) {
        list.refetch();
    }

    private userAccessRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>{get(item, 'id', '-')}</td>
            <td>
                <IriPresenter iri={get(item, 'site.@id')} render={(site: any) =>
                    get(site, 'name')
                }/>
            </td>
            <td>
                <div className="btn-group btn-group-xs resource-modal-fixup">
                    <ResourceModal
                        extClass="btn-sm"
                        title={'Edit'}
                        entity={'modal-user-access'}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        config={{user: `/user/${this.props.ENTITY_ID}`}}
                        entityId={item.id || item['@id'].replace('/user-access/', '')}
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.deleteUserAccess(item, actions, list)}>Delete User access</a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }

    private async deleteUserAccess(item: any, ListActions: ListActions, list: ListLib) {
        const answer = await Notification.delete();

        if (answer === true) {
            try {
                await ListActions.delete(item['@id']);
                list.refetch();
            } catch (error) {
                Notification.error('Error', error.message);
                false;
            } finally {

            }
        }
    }
    private userAccessSubscriptionsRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>{get(item, 'id', '-')}</td>
            <td>
                {get(item, 'startDate') &&
                    moment(get(item, 'startDate')).format('DD/MM/Y H:mm')
                }
            </td>
            <td>
                {moment(get(item, 'endDate')).format('DD/MM/Y H:mm')}
            </td>
            <td>
                <IriPresenter iri={get(item, 'userAccess.@id')} render={(userAccess: any) =>
                    <IriPresenter iri={get(userAccess, 'site.@id')} render={(site: any) =>
                        get(site, 'name')
                    }/>
                }/>
            </td>
            <td>
                <ResourceModal
                    extClass="btn-sm"
                    title={'Edit'}
                    entity={'modal-user-access-subscription'}
                    onUpdateSuccessful={(value: any) => list.refetch()}
                    config={{user: this.props.ENTITY_ID }}
                    entityId={item.id || item['@id'].replace('/user-access-subscription/', '')}
                />
            </td>
        </tr>;
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.user.tsx